import type { RegexPattern } from '../types';

/**
 * @group Constants
 * @summary <blockquote>Regex patterns for email validation.</blockquote>
 * 
 * Patterns used to validate email address formats.
 */
export const EMAIL_PATTERNS = {
  /**
   * Validates standard email address format
   * Based on RFC 5322 simplified specification
   */
  EMAIL_ADDRESS: {
    regex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    description: 'Validates standard email address format (RFC 5322 simplified)',
    examples: ['user@example.com', 'test.email+tag@example.co.uk', 'user_name@example-domain.com'],
    counterExamples: ['invalid', '@example.com', 'user@', 'user@.com', 'user name@example.com'],
  } as RegexPattern,
} as const;
